import type { LucideIcon } from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  hash?: string;
}

export function ServiceCard({ icon: Icon, title, description, hash }: ServiceCardProps) {
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-border bg-card p-6 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:bg-ink hover:shadow-elegant">
      <div className="mb-5 grid h-12 w-12 place-items-center rounded-xl bg-gradient-hero text-primary-foreground shadow-elegant transition-transform duration-300 group-hover:scale-105">
        <Icon size={22} />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground transition-colors group-hover:text-ink-foreground">
        {title}
      </h3>
      <p className="mb-4 text-sm leading-relaxed text-muted-foreground transition-colors group-hover:text-ink-muted">
        {description}
      </p>
      <Link
        to={hash ? `/services/${hash}` : "/services"}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-primary transition-all hover:gap-2.5 group-hover:text-primary-glow"
      >
        Learn more<span className="sr-only"> about {title}</span> <ArrowRight size={14} />
      </Link>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-hero opacity-0 transition-opacity group-hover:opacity-100" />
    </div>
  );
}
